export const ElasticubeIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icon/general/elastic cube">
        <path
          id="icon/general/elastic cube_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5 5.97266L5 8.13932V15.833L11.4805 18.5332L18 16.3601V8.13932L11.5 5.97266ZM6 9.19342V15.1664L11 17.2497V10.8601L6 9.19342ZM12 10.8601V17.306L17 15.6393V9.19342L12 10.8601ZM15.9189 8.4997L11.5 7.02675L7.08114 8.4997L11.5 9.97266L15.9189 8.4997Z"
          fill="#262E3D"
          fillOpacity="0.67"
        />
      </g>
    </svg>
  );
};
